import { create } from 'zustand';

import { GetDocumentTypesParams, getZones, getZonesParams } from '@/shared/actions/erp';
import {
  getCities,
  getCitiesParams,
} from '@/shared/actions/erp/cities.actions';
import { getCountriesFetch } from '@/shared/actions/erp/countries.actions';
import {
  getProvinces,
  getProvincesParams,
} from '@/shared/actions/erp/provinces.actions';
import {
  GetSectorsParams,
  getSectors,
} from '@/shared/actions/erp/sectors.actions';
import {
  City,
  Country,
  Province,

} from '@/shared/interfaces';
import { Sector, Zone } from '@/shared/interfaces/erp/mantenimiento-operaciones';

interface GeographyState {
  countries: Country[];
  provinces: Province[];
  cities: City[];
  sectors: Sector[];
  zones: Zone[];

  isLoading: boolean;
  isLoadingCountries: boolean;
  isLoadingProvinces: boolean;
  isLoadingCities: boolean;
  isLoadingSectors: boolean;
  isLoadingZones: boolean;

  getCountries: (params?: GetDocumentTypesParams) => Promise<void>;
  getProvinces: (params?: getProvincesParams) => Promise<void>;
  getCities: (params?: getCitiesParams) => Promise<void>;
  getSectors: (params?: GetSectorsParams) => Promise<void>;
  setIsLoadingCities: (isLoading: boolean) => void;
  getZones: (params?: getZonesParams) => Promise<void>;
}

export const useGeographyStore = create<GeographyState>(set => ({
  countries: [],
  provinces: [],
  cities: [],
  sectors: [],
  zones: [],
  isLoading: false,
  isLoadingCountries: false,
  isLoadingCities: false,
  isLoadingProvinces: false,
  isLoadingSectors: false,
  isLoadingZones: false,

  getCountries: async params => {
    set({ isLoading: true, isLoadingCountries: true });
    const res = await getCountriesFetch(params);

    set({
      countries: res.data.data,
      isLoading: false,
      isLoadingCountries: false,
    });
  },

  getProvinces: async params => {
    set({ isLoading: true, isLoadingProvinces: true });
    const res = await getProvinces(params);

    set({
      provinces: res.data.data,
      isLoading: false,
      isLoadingProvinces: false,
    });
  },
  getCities: async params => {
    set({ isLoading: true, isLoadingCities: true });
    const res = await getCities(params);

    set({ cities: res.data.data, isLoading: false, isLoadingCities: false });
  },
  getSectors: async params => {
    set({ isLoading: true, isLoadingSectors: true });
    const res = await getSectors(params);

    set({ sectors: res.data.data, isLoading: false, isLoadingSectors: false });
  },

  setIsLoadingCities: isLoading => set({ isLoading: isLoading }),

  getZones: async params => {
    set({ isLoading: true, isLoadingZones: true });
    const res = await getZones(params);

    set({ zones: res.data.data, isLoading: false, isLoadingZones: false });
  },
}));
